import cn from 'classnames';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const ModalSlide = ({
  ariaLabel,
  description,
  dskImg,
  headingRef,
  largeHeader,
  mblImg,
  title,
  transitionRef,
}) => {
  const isTempo = useBrand(TEMPO);

  return (
    <section className="text-center" ref={transitionRef}>
      <img
        className="invisible m-auto hidden w-[40vw] bp2:visible bp2:block bp2:w-[90vw] bp2:max-w-[450px]"
        alt={title}
        src={dskImg}
      />
      <img
        className="visible m-auto block w-[65%] bp2:invisible bp2:hidden bp2:w-[90vw] bp2:max-w-[450px]"
        alt={title}
        src={mblImg}
      />
      <div className="-ml-8 h-px w-[calc(100%+64px)] bg-charcoal-60" />
      <h1
        ref={headingRef}
        tabIndex={0}
        aria-label={ariaLabel}
        className={cn(
          largeHeader ? 'mb-1 mt-5' : 'mb-2 mt-4',
          isTempo ? 'h4 text-tempo-blue-90' : `${largeHeader ? 'h4' : 'h5'} text-green-100`
        )}
      >
        {title}
      </h1>
      <p className={cn('text font-normal', isTempo && 'text-secondary')}>{description}</p>
    </section>
  );
};

ModalSlide.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dskImg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  headingRef: PropTypes.object,
  isBasketRedesign: PropTypes.bool,
  mblImg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  largeHeader: PropTypes.bool,
  transitionRef: PropTypes.object,
  ariaLabel: PropTypes.string,
};

export default ModalSlide;
